<template>
  <div>
    <div
      :class="claseSeccionValidacion(comprador.validacionKyc, true)"
    >
      <FormularioCompradorJuridico
        :indice="indice"
        :comprador.sync="comprador"
        :bloquearCampos="!readonly && bloquearCampos"
        :readonly="readonly"
        :guardarYEnviar="guardarYEnviar"
        @autocompletar="autorellenarCompradorKycJuridico"
      />
      <v-layout v-if="fullKyc && getGenerarContratoKyc" wrap>
        <v-flex xs12 md6 xl6 px-2>
          <o-numeric-text-field
            :label="$t('reservas.kyc.volumenNegocio')"
            :name="'volumenNegocio[' + indice + ']'"
            :rulesProps="[rules.requiredIf(guardarYEnviar), rules.mayorIgual(0), rules.menor(Math.pow(10, 10))]"
            v-model="comprador.kycJuridico.volumen"
            suffix="€"
            :readonly="readonly"
          />
        </v-flex>
        <v-flex xs12 md6 xl6 px-2>
          <v-select
            :items="getPropositosContractuales"
            item-text="descripcionPropositoContractual"
            :name="'propositoContractual[' + indice + ']'"
            item-value="codigoPropositoContractual"
            :label="$t('reservas.kyc.propositoContractual')"
            :rules="[rules.requiredIf(guardarYEnviar)]"
            v-model="comprador.codigoPropositoContractual"
            :readonly="readonly"
          />
        </v-flex>
        <v-flex xs12 md12 xl12 px-2>
          <v-select
            :items="getOrigenFondos"
            item-text="descripcionOrigenFondos"
            item-value="codigoOrigenFondos"
            :label="$t('reservas.kyc.origenFondos')"
            :name="'origenFondos[' + indice + ']'"
            :rules="[rules.requiredIf(guardarYEnviar)]"
            :value="comprador.origenFondos"
            @input="comprador.origenFondos = $event"
            multiple
            :readonly="readonly"
          />
        </v-flex>
      </v-layout>
      <v-flex shrink v-if="revisando">
            <v-btn
              block
              color="primary"
              @click="comprador.validacionKyc.datosCompradorValidos = !comprador.validacionKyc.datosCompradorValidos"
              :label="$t('reservas.kyc.checkSeccion')"
              hide-details
            >
            {{comprador.validacionKyc.datosCompradorValidos ? $t('reservas.kyc.rechazarSeccion') : $t('reservas.kyc.validarSeccion')}}
            </v-btn>
        </v-flex>
    </div>
    <div 
      v-if="fullKyc && getGenerarContratoKyc"
      :class="claseSeccionValidacion(comprador.validacionKyc, false)"
    >
      <!-- <v-layout justify-start v-if="revisando">
        <v-flex shrink>
          <v-checkbox
            color="primary"
            v-model="comprador.validacionKyc.datosRepresentanteValidos"
            label="Marcar sección como válida"
            class="pb-2"
            hide-details
          />
        </v-flex>
      </v-layout> -->
      <v-layout wrap px-2 style="margin-top: 10px">
        <v-flex xs12>
          <label class="theme--light v-label">
            {{$t('reservas.kyc.titularesReales')}}
          </label>
        </v-flex>
      </v-layout>
      <slide-y-list group tag="div">
        <v-layout :column="$vuetify.breakpoint.xsOnly" mb-3 mt-3
          v-for="(titular, i) in comprador.kycJuridico.titulares"
          :key="'titular'+titular.id_temporal+titular.id"
          align-center
        >
          <v-layout :wrap="$vuetify.breakpoint.lgAndDown">
            <v-flex xs12 md6 lg4 px-2>
              <v-text-field
                :label="$t('reservas.kyc.nombreApellidos')"
                :name="'titular['+ indice +']NombreApellido[' + i +']'"
                :rules="[rules.requiredIf(guardarYEnviar), rules.max(256)]"
                v-model="titular.nombre"
                :readonly="readonly"
                browser-autocomplete="OVERTITULARNOMBRE"
              />
            </v-flex>
            <v-flex xs12 md6 lg4 px-2>
              <v-text-field
                :label="$t('reservas.kyc.dni')"
                :name="'titular['+ indice +']documentoIdentidad[' + i +']'"
                :rules="[rules.requiredIf(guardarYEnviar), rules.max(20)]"
                v-model="titular.nif"
                :readonly="readonly"
              />
            </v-flex>
            <v-flex xs12 md6 lg4 px-2>
              <v-autocomplete
                :label="$t('reservas.kyc.nacionalidad')"
                :name="'titular['+ indice +']nacionalidad[' + i +']'"
                :items="getNacionalidades"
                item-text="denominacionNacionalidad"
                item-value="codigoNacionalidad"
                v-model="titular.codigoNacionalidad"
                :readonly="readonly"
                :clearable="!readonly"
                :rules="[rules.requiredIf(guardarYEnviar)]"
              />
            </v-flex>
            <v-flex xs12 md6 lg4 px-2>
              <v-autocomplete
                :label="$t('reservas.kyc.paisResidencia')"
                :name="'titular['+ indice +']paisResidencia[' + i +']'"
                :items="getPaises"
                item-text="denominacionPais"
                item-value="codigoPais"
                v-model="titular.codigoPais"
                :readonly="readonly"
                :clearable="!readonly"
                :rules="[rules.requiredIf(guardarYEnviar)]"
                browser-autocomplete="OVERTITULARNPAIS"
              />
            </v-flex>
            <v-flex xs12 md6 lg4 px-2>
              <o-numeric-text-field
                :label="$t('reservas.kyc.porcentajeParticipacion')"
                :name="'titular['+ indice +']participacion[' + i +']'"
                :rulesProps="[rules.requiredIf(guardarYEnviar), rules.porcentaje]"
                v-model="titular.porcentajeParticipacion"
                suffix="%"
                :readonly="readonly"
              />
            </v-flex>
          </v-layout>
          <v-flex xs1 md1 lg1 px-2 v-if="!readonly">
            <v-btn
              icon
              class="mb-0"
              @click="mostrarAvisoBorrarTitular(i)"
            >
              <v-icon medium color="primary">remove_circle_outline</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
        <v-layout mt-2 v-if="!readonly" key="add_titular">
          <v-flex px-4>
            <v-btn
              large
              color="primary"
              :disabled="waitingForLoad || cargandoExterior"
              @click="addTitular"
            >
              {{$t('reservas.kyc.addTitular')}}
            </v-btn>
          </v-flex>
        </v-layout>
      </slide-y-list>
      <v-layout wrap px-2 style="margin-top: 10px">
        <v-flex xs12>
          <label class="theme--light v-label">
            {{$t('reservas.kyc.apoderados')}}
          </label>
        </v-flex>
      </v-layout>
      <slide-y-list group tag="div">
        <v-layout :column="$vuetify.breakpoint.xsOnly" mb-3 mt-3
          v-for="(apoderado, i) in comprador.kycJuridico.apoderados"
          :key="'apoderado'+apoderado.id_temporal+apoderado.id"
          align-center
        >
          <v-layout :wrap="$vuetify.breakpoint.lgAndDown">
            <v-flex xs12 md6 lg4 px-2>
              <v-text-field
                :label="$t('reservas.kyc.nombreApellidos')"
                :name="'apoderado['+ indice +']NombreApellido[' + i +']'"
                :rules="[rules.requiredIf(guardarYEnviar), rules.max(256)]"
                v-model="apoderado.nombre"
                :readonly="readonly"
                browser-autocomplete="OVERAPODERADONOMBRE"
              />
            </v-flex>
            <v-flex xs12 md6 lg4 px-2>
              <v-text-field
                :label="$t('reservas.kyc.dni')"
                :name="'apoderado['+ indice +']documentoIdentidad[' + i +']'"
                :rules="[rules.requiredIf(guardarYEnviar), rules.max(20)]"
                v-model="apoderado.nif"
                :readonly="readonly"
              />
            </v-flex>
            <v-flex xs12 md6 lg4 px-2>
              <v-autocomplete
                :label="$t('reservas.kyc.nacionalidad')"
                :name="'apoderado['+ indice +']nacionalidad[' + i +']'"
                :items="getNacionalidades"
                item-text="denominacionNacionalidad"
                item-value="codigoNacionalidad"
                v-model="apoderado.codigoNacionalidad"
                :readonly="readonly"
                :clearable="!readonly"
                :rules="[rules.requiredIf(guardarYEnviar)]"
              />
            </v-flex>
            <v-flex xs12 md6 lg4 px-2>
              <v-autocomplete
                :label="$t('reservas.kyc.paisResidencia')"
                :name="'apoderado['+ indice +']paisResidencia[' + i +']'"
                :items="getPaises"
                item-text="denominacionPais"
                item-value="codigoPais"
                v-model="apoderado.codigoPais"
                :readonly="readonly"
                :clearable="!readonly"
                :rules="[rules.requiredIf(guardarYEnviar)]"
                browser-autocomplete="OVERAPODERADOPAIS"
              />
            </v-flex>
            <v-flex xs12 md6 lg4 px-2>
              <v-text-field
                :label="$t('reservas.kyc.cargo')"
                :name="'apoderado['+ indice +']cargo[' + i +']'"
                :rules="[rules.requiredIf(guardarYEnviar), rules.max(256)]"
                v-model="apoderado.cargo"
                :readonly="readonly"
              />
            </v-flex>
          </v-layout>
          <v-flex xs1 md1 lg1 px-2 v-if="!readonly">
            <v-btn
              icon
              class="mb-0"
              @click="mostrarAvisoBorrarApoderado(i)"
            >
              <v-icon medium color="primary">remove_circle_outline</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
        <v-layout mt-2 v-if="!readonly" key="add_apoderado">
          <v-flex px-4>
            <v-btn
              large
              color="primary"
              :disabled="waitingForLoad || cargandoExterior"
              @click="addApoderado"
            >
              {{$t('reservas.kyc.addApoderado')}}
            </v-btn>
          </v-flex>
        </v-layout>
      </slide-y-list>
      <v-layout mt-3 column>
        <v-flex xs12 mb-2>
          <label class="theme--light v-label">
            {{$t('reservas.kyc.cargosPublicos')}}
          </label>
          <v-radio-group
            class="mt-1 px-2"
            v-model="comprador.cargoPublico"
            hide-details
            :rules="[rules.requiredIf(guardarYEnviar)]"
            row
            :disabled="readonly"
          >
            <v-radio
              color="primary"
              :label="$t('reservas.kyc.si')"
              :value="true"
              class="mb-0"
            />
            <v-radio
              color="primary"
              :label="$t('reservas.kyc.no')"
              :value="false"
              class="mb-0"
            />
          </v-radio-group>
          <v-slide-y-transition>
            <div class="mb-3" v-if="comprador.cargoPublico">
              <v-layout wrap>
                <v-flex xs12 px-2>
                  <v-text-field
                    :label="$t('reservas.kyc.descripcion')"
                    :name="'cargoDescripcion[' + indice + ']'"
                    :rules="[rules.requiredIf(guardarYEnviar), rules.max(256)]"
                    hide-details
                    v-model="comprador.kycJuridico.cargoPublicoDescripcion"
                    :readonly="readonly"
                  />
                </v-flex>
              </v-layout>
            </div>
          </v-slide-y-transition>
        </v-flex>
        <v-flex xs12 px-2>
          <v-radio-group ref="radioCotizada"
            v-model="comprador.kycJuridico.cotizada"
            :rules="[ruleCotizada]"
            :disabled="readonly"
          >
            <v-layout>
              <label d-inline-block class="mr-2 v-label">{{$t('reservas.kyc.sociedadCotizada')}}</label>
              <v-radio
                color="primary"
                :label="$t('reservas.kyc.si')"
                :value="true"
                class="mb-0"
              />
              <v-radio
                color="primary"
                :label="$t('reservas.kyc.no')"
                :value="false"
                class="mb-0"
              />
            </v-layout>
          </v-radio-group>
          <v-slide-y-transition>
            <div class="mb-3" v-if="!comprador.kycJuridico.cotizada">
              <v-layout wrap px-2 style="margin-top: 10px">
                <v-flex xs12>
                  <label class="theme--light v-label">
                    {{$t('reservas.kyc.identifiquePersonas')}}
                  </label>
                </v-flex>
              </v-layout>
              <slide-y-list group tag="div">
                <v-layout :column="$vuetify.breakpoint.xsOnly" mb-3 mt-3
                  v-for="(titularNoCotizada, i) in comprador.kycJuridico.titularesNoCotizada"
                  :key="'titularNoCotizada'+titularNoCotizada.id_temporal+titularNoCotizada.id"
                  align-center
                >
                  <v-layout :wrap="$vuetify.breakpoint.lgAndDown">
                    <v-flex xs12 md6 lg4 px-2>
                      <v-text-field
                        :label="$t('reservas.kyc.nombreApellidos')"
                        :name="'noCotizada['+ indice +']nombreApellido[' + i +']'"
                        :rules="[rules.requiredIf(guardarYEnviar), rules.max(256)]"
                        v-model="titularNoCotizada.nombre"
                        :readonly="readonly"
                        browser-autocomplete="OVERTITULARNOCOTNOMBRE"
                      />
                    </v-flex>
                    <v-flex xs12 md6 lg4 px-2>
                      <v-text-field
                        :label="$t('reservas.kyc.dni')"
                        :name="'noCotizada['+ indice +']documentoIdentidad[' + i +']'"
                        :rules="[rules.requiredIf(guardarYEnviar), rules.max(20)]"
                        v-model="titularNoCotizada.nif"
                        :readonly="readonly"
                      />
                    </v-flex>
                    <v-flex xs12 md6 lg4 px-2>
                      <v-autocomplete
                        :label="$t('reservas.kyc.nacionalidad')"
                        :name="'noCotizada['+ indice +']nacionalidad[' + i +']'"
                        :items="getNacionalidades"
                        item-text="denominacionNacionalidad"
                        item-value="codigoNacionalidad"
                        v-model="titularNoCotizada.codigoNacionalidad"
                        :readonly="readonly"
                        :clearable="!readonly"
                        :rules="[rules.requiredIf(guardarYEnviar)]"
                      />
                    </v-flex>
                    <v-flex xs12 md6 lg4 px-2>
                      <v-autocomplete
                        :label="$t('reservas.kyc.paisResidencia')"
                        :items="getPaises"
                        item-text="denominacionPais"
                        item-value="codigoPais"
                        v-model="titularNoCotizada.codigoPais"
                        :readonly="readonly"
                        :clearable="!readonly"
                        :rules="[rules.requiredIf(guardarYEnviar)]"
                        browser-autocomplete="OVERTITULARNOCOTPAIS"
                      />
                    </v-flex>
                    <v-flex xs12 md6 lg4 px-2>
                      <o-numeric-text-field
                        :label="$t('reservas.kyc.porcentajeParticipacionLetras')"
                        :name="'noCotizada['+ indice +']porcentajeParticipacion[' + i +']'"
                        :rulesProps="[rules.requiredIf(guardarYEnviar), rules.porcentaje]"
                        v-model="titularNoCotizada.porcentajeParticipacion"
                        suffix="%"
                        :readonly="readonly"
                      />
                    </v-flex>
                  </v-layout>
                  <v-flex xs1 md1 lg1 px-2 v-if="!readonly">
                    <v-btn
                      icon
                      class="mb-0"
                      @click="mostrarAvisoBorrarTitularNoCotizada(i)"
                    >
                      <v-icon medium color="primary">remove_circle_outline</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
                <v-layout mt-2 v-if="!readonly" key="id_titularNoCotizada">
                  <v-flex px-4>
                    <v-btn
                      large
                      color="primary"
                      :disabled="waitingForLoad || cargandoExterior"
                      @click="addTitularNoCotizada"
                    >
                      {{$t('reservas.kyc.addPerson')}}
                    </v-btn>
                  </v-flex>
                </v-layout>
              </slide-y-list>
            </div>
          </v-slide-y-transition>
        </v-flex>
        <v-flex xs12 px-2>
          <v-radio-group
            v-model="comprador.kycJuridico.naturaleza"
            :rules="[rules.requiredIf(guardarYEnviar)]"
            column
            class="fullWidth"
            :disabled="readonly"
          >
            <v-layout wrap align-center justify-start>
              <label d-inline-block class="mr-2 mb-2 v-label">{{$t('reservas.kyc.naturalezaEntidad')}}</label>
              <v-flex
                xs12
                px-2
                v-for="naturalezaEntidad in naturalezaEntidades"
                :key="naturalezaEntidad.value"
              >
                <v-radio
                  :label="naturalezaEntidad.text"
                  :value="naturalezaEntidad.value"
                  class="mb-2 mr-0"
                  color="primary"
                />
              </v-flex>
            </v-layout>
          </v-radio-group>
        </v-flex>
        <v-flex xs12 px-2>
          <v-radio-group
            v-model="comprador.kycJuridico.ambito"
            :rules="[rules.requiredIf(guardarYEnviar)]"
            row
            class="fullWidth"
            :disabled="readonly"
          >
            <v-layout wrap align-center justify-start>
              <v-flex xs12 md3>
                <label d-inline-block class="mr-2 mb-2 v-label">{{$t('reservas.kyc.ambitoActividad')}}</label>
              </v-flex>
              <v-flex
                xs12
                md3
                px-2
                v-for="ambito in ambitos"
                :key="ambito.value"
              >
                <v-radio
                  :label="ambito.text"
                  :value="ambito.value"
                  class="mb-2"
                  color="primary"
                />
              </v-flex>
            </v-layout>
          </v-radio-group>
        </v-flex>
      </v-layout>
      <v-flex shrink v-if="revisando">
            <v-btn
              block
              color="primary"
              @click="comprador.validacionKyc.datosRepresentanteValidos = !comprador.validacionKyc.datosRepresentanteValidos"
              label="Marcar sección como válida"
              hide-details
            >
            {{comprador.validacionKyc.datosRepresentanteValidos ? $t('reservas.kyc.rechazarSeccion') : $t('reservas.kyc.validarSeccion')}}
            </v-btn>
        </v-flex>
    </div>
    <v-fade-transition>
      <custom-dialog 
        v-if="mostrarBorrarTitular" 
        v-model="mostrarBorrarTitular"
        @aceptar="mostrarBorrarTitular = $event"
      >
        <KycBorrar 
          :description="descripcionBorrar('Titular', comprador.kycJuridico.titulares[indiceBorrar].nombre, indiceBorrar)"
          :titulo="$t('reservas.kyc.eliminarTitular')"
          @continuar="borrarTitular"
        />
      </custom-dialog>
    </v-fade-transition>
    <v-fade-transition>
      <custom-dialog 
        v-if="mostrarBorrarApoderado" 
        v-model="mostrarBorrarApoderado"
        @aceptar="mostrarBorrarApoderado = $event"
      >
        <KycBorrar 
          :description="descripcionBorrar('Apoderado', nombreBorrar, indiceBorrar)"
          :titulo="$t('reservas.kyc.eliminarApoderado')"
          @continuar="borrarApoderado"
        />
      </custom-dialog>
    </v-fade-transition>
    <v-fade-transition>
      <custom-dialog 
        v-if="mostrarBorrarTitularNoCotizada" 
        v-model="mostrarBorrarTitularNoCotizada"
        @aceptar="mostrarBorrarTitularNoCotizada = $event"
      >
        <KycBorrar 
          :description="descripcionBorrar('NoCotizada', nombreBorrar, indiceBorrar)"
          :titulo="$t('reservas.kyc.eliminarPersonaSociedad')"
          @continuar="borrarTitularNoCotizada"
        />
      </custom-dialog>
    </v-fade-transition>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import rules from '@/mixins/rules'
import MixinComprador from '@/mixins/comprador'
import MixinEstadoKyc from '@/mixins/estadosReserva/estadoKyc'
import FormularioCompradorJuridico from '@/components/reservas/comprador/FormularioCompradorJuridico'
import moment from 'moment'
import KycBorrar from './KycBorrar'

export default {
  mixins: [rules, MixinComprador, MixinEstadoKyc],
  props: {
    comprador: {
      type: Object,
      required: true
    },
    cargandoExterior: {
      type: Boolean,
      required: true
    },
    waitingForLoad: {
      type: Boolean,
      required: true
    },
    indice: {
      type: Number,
      default: 0
    },
    fullKyc: {
      type: Boolean,
      default: true
    },
    bloquearCampos: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    revisando: {
      type: Boolean,
      default: false
    },
    guardarYEnviar: {
      type: Boolean,
      default: false
    }
  },
  components: {
    FormularioCompradorJuridico,
    KycBorrar
  },
  data () {
    return {
      menuFechaNacimiento: false,
      mostrarBorrarTitular: false,
      mostrarBorrarApoderado: false,
      mostrarBorrarTitularNoCotizada: false,
      nombreBorrar: null
    }
  },
  computed: {
    ...mapGetters({
      getEstadosCiviles: 'maestros/estadosCiviles/getAll',
      getOrigenFondos: 'maestros/origenFondos/getAll',
      getPropositosContractuales: 'maestros/propositosContractuales/getAll',
      getProfesiones: 'maestros/profesiones/getAll',
      getPaises: 'maestros/paises/getAll',
      getNacionalidades: 'maestros/nacionalidades/getAll',
      getGenerarContratoKyc: 'modulosOrdenes/getGenerarContratoKyc'
    })
  },
  methods: {
    descripcionBorrar (tipo, nombre, indiceBorrar) {
      return this.$t('reservas.kyc.confirmacionEliminar' + tipo,
        {
          nombre: nombre ? '"' + nombre + '"' : indiceBorrar + 1
        }
      )
    },
    formatDate (d) {
      return d ? moment(d).format('DD/MM/YYYY') : null
    },
    ruleCotizada (v) {
      return (!this.guardarYEnviar || v || (!v && this.comprador.kycJuridico.titularesNoCotizada.length > 0)) || this.$t('reservas.kyc.avisoMercado')
    },
    addTitular () {
      this.comprador.kycJuridico.titulares.push(this.nuevoTitularReal())
    },
    addApoderado () {
      this.comprador.kycJuridico.apoderados.push(this.nuevoApoderado())
    },
    addTitularNoCotizada () {
      this.comprador.kycJuridico.titularesNoCotizada.push(this.nuevoTitularNoCotizada())
      this.$refs.radioCotizada.validate()
    },
    mostrarAvisoBorrarTitular (i) {
      this.nombreBorrar = this.comprador.kycJuridico.titulares[i].nombre
      this.indiceBorrar = i
      this.mostrarBorrarTitular = true
    },
    mostrarAvisoBorrarApoderado (i) {
      this.nombreBorrar = this.comprador.kycJuridico.apoderados[i].nombre
      this.indiceBorrar = i
      this.mostrarBorrarApoderado = true
    },
    mostrarAvisoBorrarTitularNoCotizada (i) {
      this.indiceBorrar = i
      this.nombreBorrar = this.comprador.kycJuridico.titularesNoCotizada[i].nombre
      this.mostrarBorrarTitularNoCotizada = true
    },
    borrarTitular () {
      this.mostrarBorrarTitular = false
      this.comprador.kycJuridico.titulares.splice(this.indiceBorrar, 1)
      this.indiceBorrar = -1
    },
    borrarApoderado () {
      this.mostrarBorrarApoderado = false
      this.comprador.kycJuridico.apoderados.splice(this.indiceBorrar, 1)
      this.indiceBorrar = -1
    },
    borrarTitularNoCotizada () {
      this.mostrarBorrarTitularNoCotizada = false
      this.comprador.kycJuridico.titularesNoCotizada.splice(this.indiceBorrar, 1)
      this.indiceBorrar = -1
      this.$refs.radioCotizada.validate()
    },
    claseSeccionValidacion (validacionKyc, isDatosComprador) {
      // Devuelve true o false según si los datos del kyc son de comprador o representante
      let valido = false
      if (validacionKyc != null) {
        valido = isDatosComprador ? validacionKyc.datosCompradorValidos : validacionKyc.datosRepresentanteValidos
      }
      return (this.kycRechazado || this.revisando) && validacionKyc != null
        ? ['px-2', 'my-2', 'section', valido ? 'section-validado' : 'section-rechazado']
        : []
    }
  }
}
</script>

<style lang="stylus" scoped>
@require '~vuetify/src/stylus/settings/_colors'

.fullWidth.v-input--selection-controls .v-input__control
  width: 100% !important

</style>




// WEBPACK FOOTER //
// src/components/reservas/kyc/KycCompradorJuridico.vue